// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/tarot.yaml

import type { TarotReferenceCard } from "./types";

export const wandsTarotCards = [
  {
    image_description: "",
    id: 22,
    name_en: "Ace of Wands",
    name_hi: "दण्ड का इक्का",
    vedic_name: "Agni Beej (Seed of Fire)",
    vedic_parallel:
      "Like the first spark of a yajna — the sacred fire from which all action begins",
    upright: {
      keywords: ["inspiration", "new venture", "creative spark", "potential"],
      meaning: "A powerful new beginning ignites. Creative energy and ambition surge.",
      advice: "Act on this inspiration before it fades. The spark is real.",
    },
    reversed: {
      keywords: ["delays", "hesitation", "blocked creativity", "false start"],
      meaning: "The fire is there but struggling to catch. Timing or preparation needs work.",
      advice: "Refine your plan before launching. The spark will return.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 23,
    name_en: "Two of Wands",
    name_hi: "दण्ड का दो",
    vedic_name: "Disha Nirdharan (Choosing Direction)",
    vedic_parallel: "Like Rama at the crossroads — the vision is clear, now choose the path",
    upright: {
      keywords: ["planning", "decisions", "discovery", "future vision"],
      meaning: "You see the possibilities. Now is the time to plan and choose your direction.",
      advice: "Think big but plan carefully. Vision without strategy is a daydream.",
    },
    reversed: {
      keywords: ["fear of the unknown", "lack of planning", "playing it safe"],
      meaning: "Fear of the unknown keeps you small. The comfort zone has become a cage.",
      advice: "Take the first step even if the whole path is not visible.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 24,
    name_en: "Three of Wands",
    name_hi: "दण्ड का तीन",
    vedic_name: "Prateeksha (The Waiting)",
    vedic_parallel: "Like a merchant watching ships depart — seeds sown, now awaiting fruit",
    upright: {
      keywords: ["expansion", "foresight", "progress", "overseas opportunity"],
      meaning: "Your efforts are bearing fruit. Expansion and progress unfold naturally.",
      advice: "Keep the momentum. What you started is working.",
    },
    reversed: {
      keywords: ["delays", "frustration", "obstacles to progress"],
      meaning: "Expected results are delayed. Patience is tested but not in vain.",
      advice: "Reassess your approach rather than abandoning the journey.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 25,
    name_en: "Four of Wands",
    name_hi: "दण्ड का चार",
    vedic_name: "Utsav (The Celebration)",
    vedic_parallel: "Like a griha pravesh ceremony — the joy of arriving at a milestone",
    upright: {
      keywords: ["celebration", "harmony", "homecoming", "community", "joy"],
      meaning: "A milestone reached. Celebrate with those who supported the journey.",
      advice: "Enjoy this moment. Gratitude amplifies joy.",
    },
    reversed: {
      keywords: ["lack of support", "instability", "postponed celebration"],
      meaning: "The foundation feels shaky. Community support may be lacking.",
      advice: "Strengthen your base before building higher.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 26,
    name_en: "Five of Wands",
    name_hi: "दण्ड का पाँच",
    vedic_name: "Sangharsh (The Struggle)",
    vedic_parallel:
      "Like the wrestling matches at swayamvars — healthy competition that reveals strength",
    upright: {
      keywords: ["conflict", "competition", "tension", "disagreement", "growth"],
      meaning: "Conflict and competition test you. Not all tension is harmful.",
      advice: "Compete with integrity. Struggle builds the strength success demands.",
    },
    reversed: {
      keywords: ["avoiding conflict", "inner tension", "compromise"],
      meaning: "Avoiding necessary confrontation. Peace at any price is not peace.",
      advice: "Face the conflict directly. Avoidance makes it worse.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 27,
    name_en: "Six of Wands",
    name_hi: "दण्ड का छह",
    vedic_name: "Vijay Yatra (The Victory Procession)",
    vedic_parallel: "Like Rama's return to Ayodhya — public recognition of dharmic victory",
    upright: {
      keywords: ["victory", "recognition", "success", "pride", "achievement"],
      meaning: "Public recognition and triumph. Your efforts are seen and honored.",
      advice: "Accept praise gracefully. Success shared is success multiplied.",
    },
    reversed: {
      keywords: ["ego", "fall from grace", "delayed recognition", "arrogance"],
      meaning: "Success may breed arrogance, or recognition is delayed.",
      advice: "Stay humble. The praise belongs to the effort, not the ego.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 28,
    name_en: "Seven of Wands",
    name_hi: "दण्ड का सात",
    vedic_name: "Raksha Sthiti (The Defensive Stand)",
    vedic_parallel: "Like Abhimanyu in the Chakravyuha — holding ground against overwhelming odds",
    upright: {
      keywords: ["perseverance", "defense", "standing your ground", "challenge"],
      meaning: "You face opposition but have the higher ground. Hold your position.",
      advice: "Do not retreat from what you know is right.",
    },
    reversed: {
      keywords: ["overwhelm", "giving up", "exhaustion", "feeling attacked"],
      meaning: "The fight is draining you. Is this battle worth the cost?",
      advice: "Know when to stand and when to step back strategically.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 29,
    name_en: "Eight of Wands",
    name_hi: "दण्ड का आठ",
    vedic_name: "Tvarit Gati (Swift Movement)",
    vedic_parallel: "Like Hanuman's leap to Lanka — rapid, purposeful, unstoppable action",
    upright: {
      keywords: ["speed", "movement", "swift action", "progress", "momentum"],
      meaning: "Things accelerate rapidly. News, travel, or breakthroughs arrive fast.",
      advice: "Ride the momentum. Swift action is favored now.",
    },
    reversed: {
      keywords: ["delays", "frustration", "waiting", "scattered energy"],
      meaning: "Momentum stalls. Patience is required where speed was expected.",
      advice: "Use the delay to refine your aim.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 30,
    name_en: "Nine of Wands",
    name_hi: "दण्ड का नौ",
    vedic_name: "Antim Pariksha (The Last Test)",
    vedic_parallel:
      "Like Yudhishthira's final test at heaven's gate — persistence when all seems lost",
    upright: {
      keywords: ["resilience", "persistence", "last stand", "inner strength", "grit"],
      meaning: "You are weary but close to the finish. One final push is needed.",
      advice: "Do not quit now. The hardest part is almost behind you.",
    },
    reversed: {
      keywords: ["exhaustion", "giving up", "paranoia", "overwhelm"],
      meaning: "Fatigue clouds judgment. You may be fighting battles that are already won.",
      advice: "Rest before you break. Strength requires recovery.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 31,
    name_en: "Ten of Wands",
    name_hi: "दण्ड का दस",
    vedic_name: "Bhaar (The Burden)",
    vedic_parallel: "Like Bhishma's vow — carrying a weight that was noble but costs dearly",
    upright: {
      keywords: ["burden", "overwork", "responsibility", "exhaustion", "duty"],
      meaning: "You carry too much. Responsibility without delegation leads to burnout.",
      advice: "Delegate or drop what is not essential. Not every duty is yours.",
    },
    reversed: {
      keywords: ["release", "delegation", "relief", "letting go of burden"],
      meaning: "You are learning to set down what was never yours to carry.",
      advice: "Release one burden today. The rest will feel lighter.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 32,
    name_en: "Page of Wands",
    name_hi: "दण्ड का राजकुमार",
    vedic_name: "Agni Shishya (The Fire Student)",
    vedic_parallel: "Like young Dhruva setting out for tapasya — passionate, determined, untested",
    upright: {
      keywords: ["enthusiasm", "exploration", "discovery", "free spirit"],
      meaning: "A message of new opportunity or a young energy entering your life.",
      advice: "Follow your curiosity with passion. Enthusiasm is your guide.",
    },
    reversed: {
      keywords: ["hasty decisions", "lack of direction", "unreliable"],
      meaning: "Enthusiasm without follow-through. All spark, no sustained flame.",
      advice: "Channel your energy into one direction before it scatters.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 33,
    name_en: "Knight of Wands",
    name_hi: "दण्ड का शूरवीर",
    vedic_name: "Agni Veer (The Fire Warrior)",
    vedic_parallel: "Like Bheem charging into battle — bold, fearless, impatient for victory",
    upright: {
      keywords: ["action", "adventure", "boldness", "energy", "passion"],
      meaning: "Bold action and rapid movement. A passionate person or energy enters the scene.",
      advice: "Act decisively but do not burn bridges in your haste.",
    },
    reversed: {
      keywords: ["impulsiveness", "recklessness", "delays", "scattered"],
      meaning: "Too much fire without direction. Impulsive action causes harm.",
      advice: "Slow down. Speed without wisdom is just chaos.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 34,
    name_en: "Queen of Wands",
    name_hi: "दण्ड की रानी",
    vedic_name: "Agni Devi (The Fire Queen)",
    vedic_parallel: "Like Draupadi — fierce, magnetic, and unwavering in her convictions",
    upright: {
      keywords: ["confidence", "warmth", "determination", "vibrancy", "leadership"],
      meaning: "Radiant confidence and natural leadership. You inspire by being yourself.",
      advice: "Lead with warmth. Your presence alone transforms the room.",
    },
    reversed: {
      keywords: ["jealousy", "selfishness", "temperamental", "demanding"],
      meaning: "Confidence has tipped into arrogance or possessiveness.",
      advice: "Lead with generosity, not ego.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
  {
    image_description: "",
    id: 35,
    name_en: "King of Wands",
    name_hi: "दण्ड का राजा",
    vedic_name: "Agni Nayak (The Fire King)",
    vedic_parallel: "Like Chanakya guiding Chandragupta — visionary leadership that builds empires",
    upright: {
      keywords: ["visionary", "leadership", "big picture", "entrepreneurial", "bold"],
      meaning: "A visionary leader or the energy of bold, strategic action.",
      advice: "Lead with vision. Others will follow when the mission is clear.",
    },
    reversed: {
      keywords: ["ruthless", "impulsive leader", "vain", "overbearing"],
      meaning: "Leadership without listening. The vision has become a personal agenda.",
      advice: "Power without humility is a short reign.",
    },
    arcana: "minor",
    suit: "wands",
    element: "fire",
    vedic_element: "agni",
    suit_theme: "Action, willpower, ambition, and spiritual drive",
  },
] as const satisfies readonly TarotReferenceCard[];
